export const defaultHeaders = { 'Content-Type': 'application/json', 'Bday-Api-Token': '79241a70412c4127abaf50fa62406def' };
import { logInfo } from 'components/utils/logger';

const getAPILogMessage = (type, message) => {
  if (!type || type === 'GET') {
    return `\x1B[33m${message}  |  \x1B[36mGET  \x1B[33m|`;
  } else if (type === 'POST') {
    return `\x1B[33m${message}  |  \x1B[92mPOST  \x1B[33m|`
  } else if (type === 'PUT') {
    return `\x1B[33m${message}  |  \x1B[35mPUT  \x1B[33m|`;
  } else if (type === 'DELETE') {
    return `\x1B[33m${message}  |  \x1B[31mDELETE  \x1B[33m|`;
  }
}

export const bdayFetch = async (url, options = {}, headers = {}) => {
  const requestHeaders = { ...defaultHeaders, ...headers };
  logInfo(getAPILogMessage(options?.method || 'GET', 'API REQUEST '), url, { options, headers: requestHeaders });
  try {
    const response = await fetch(url, { ...options, headers: requestHeaders, body: JSON.stringify(options.body) });
    if (!response?.ok) {
      const errorResult = { errors: [{ field: 'general', errorMessage: response.statusText, errorCode: response.status }] };
      logInfo(getAPILogMessage(options.method || 'GET', 'API RESPONSE'), url, errorResult);
      return errorResult;
    }
    const result = await response.json();
    logInfo(getAPILogMessage(options.method || 'GET', 'API RESPONSE'), url, result);
    return result;
  } catch (error) {
    const errorResult = { errors: [{ field: 'general', errorMessage: 'Fetch failed', errorCode: 500 }] };
    logInfo(getAPILogMessage(options.method || 'GET', 'API RESPONSE'), url, errorResult);
    return errorResult;
  }
};

export const bdayGet = async (url, requestHeaders) => {
  const headers = { ...defaultHeaders, ...requestHeaders };
  logInfo(getAPILogMessage('GET', 'API REQUEST '), url, { payload: {}, headers });
  try {
    const response = await fetch(url, { method: 'GET', headers });
    if (!response?.ok) {
      const errorResult = { errors: [{ field: 'general', errorMessage: response.statusText, errorCode: response.status }] };
      logInfo(getAPILogMessage('GET', 'API RESPONSE'), url, errorResult);
      return errorResult;
    }
    const result = await response.json();
    logInfo(getAPILogMessage('GET', 'API RESPONSE'), url, result);
    return result;
  } catch (error) {
    const errorResult = { errors: [{ field: 'general', errorMessage: 'Fetch GET failed', errorCode: 500 }] };
    logInfo(getAPILogMessage('GET', 'API RESPONSE'), url, errorResult);
    return errorResult;
  }
};

export const bdayPost = async (url, payload, requestHeaders) => {
  const headers = { ...defaultHeaders, ...requestHeaders };
  logInfo(getAPILogMessage('POST', 'API REQUEST '), url, { payload, headers });
  try {
    const response = await fetch(url, { method: 'POST', headers, body: JSON.stringify(payload) });
    if (!response?.ok) {
      const errorResult = { errors: [{ field: 'general', errorMessage: response?.statusText, errorCode: response?.status }] };
      logInfo(getAPILogMessage('POST', 'API RESPONSE'), url, errorResult);
      return errorResult;
    }
    const result = await response.json();
    logInfo(getAPILogMessage('POST', 'API RESPONSE'), url, result);
    return result;
  } catch (error) {
    const errorResult = { errors: [{ field: 'general', errorMessage: 'Fetch POST failed', errorCode: 500 }] };
    logInfo(getAPILogMessage('POST', 'API RESPONSE'), url, errorResult);
    return errorResult;
  }
};

export const bdayPut = async (url, payload, requestHeaders) => {
  const headers = { ...defaultHeaders, ...requestHeaders };
  logInfo(getAPILogMessage('PUT', 'API REQUEST '), url, { payload, headers });
  try {
    const response = await fetch(url, { method: 'PUT', headers, body: JSON.stringify(payload) });
    if (!response?.ok) {
      const errorResult = { errors: [{ field: 'general', errorMessage: response?.statusText, errorCode: response?.status }] };
      logInfo(getAPILogMessage('PUT', 'API RESPONSE'), url, errorResult);
      return errorResult;
    }
    const result = await response.json();
    logInfo(getAPILogMessage('PUT', 'API RESPONSE'), url, result);
    return result;
  } catch (error) {
    const errorResult = { errors: [{ field: 'general', errorMessage: 'Fetch PUT failed', errorCode: 500 }] };
    logInfo(getAPILogMessage('PUT', 'API RESPONSE'), url, errorResult);
    return errorResult;
  }
};

export const bdayDelete = async (url, payload, requestHeaders) => {
  const headers = { ...defaultHeaders, ...requestHeaders };
  logInfo(getAPILogMessage('DELETE', 'API REQUEST '), url, { payload, headers });
  try {
    const response = await fetch(url, { method: 'DELETE', headers, body: JSON.stringify(payload) });
    if (!response?.ok) {
      const errorResult = { errors: [{ field: 'general', errorMessage: response?.statusText, errorCode: response?.status }] };
      logInfo(getAPILogMessage('DELETE', 'API RESPONSE'), url, errorResult);
      return errorResult;
    }
    const result = await response.json();
    logInfo(getAPILogMessage('DELETE', 'API RESPONSE'), url, result);
    return result;
  } catch (error) {
    const errorResult = { errors: [{ field: 'general', errorMessage: 'Fetch DELETE failed', errorCode: 500 }] };
    logInfo(getAPILogMessage('DELETE', 'API RESPONSE'), url, errorResult);
    return errorResult;
  }
};
